const filterList = [
  { _id: 1, name: "All", active: true },
  { _id: 2, name: "Romance", active: false },
  { _id: 3, name: "Action", active: false },
  { _id: 4, name: "Thriller", active: false },
  { _id: 5, name: "Horror", active: false },
  { _id: 6, name: "Adventure", active: false },
];
export default filterList;
